import { useEffect, useRef, useState } from 'react'
import { io } from 'socket.io-client'

export function useSocket(socketServer = '', onSocketMessage, onSocketConnect, onSocketDisconect) {
    const [stateSocket, setStateSocket] = useState()

    let socket = useRef(null)


    useEffect(() => {
        socket = io.connect(socketServer || process.env.REACT_APP_SOCKET_HOST, { path: '/socket' })
        if (socket) {
            socket.on('connect', () => onSocketConnect(socket));
            onSocketMessage(socket)

        }
        return () => socket.disconnect()

    }, [])

    useEffect(() => {
            setStateSocket(socket)
        },
        [socket])


    function sendMessage(message, payload) {
        stateSocket.emit(message, payload)
    }


    return {sendMessage}
}